import { Component, OnInit } from '@angular/core';
import { Store } from '../../store';
import { OverlayService } from '../../services/overlay.service';
import { CmsService } from '../../services/cms.service';
import { MenuService } from '../../services/menu.service';
import { NavigationEnd, Router } from '@angular/router';
import { AlertService } from '../../services/alert.service';
import { FacebookPixelService } from '../../modules/tracking/services/facebook-pixel.service';

@Component({
    selector: 'app-product-details-layout',
    templateUrl: './product-details-layout.component.html',
    styleUrls: ['./product-details-layout.component.scss']
})
export class ProductDetailsLayoutComponent implements OnInit {
    deviceType$ = this.store.select<string>('deviceType');
    deviceType = this.store.selectForLocal('deviceType');
    overlays$ = this.store.select<any>('overlays');
    mobileMenu$ = this.store.select<boolean>('mobileMenu');
    mobileMenuUser$ = this.store.select<boolean>('mobileMenuUser');
    thresholdGoToTop = 300;

    constructor(
        private store: Store,
        private overlayService: OverlayService,
        private router: Router,
        private alertService: AlertService,
        private cmsService: CmsService,
        private menuService: MenuService,
    ) {
        router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                let activeRoute = val.url.replace(/^\/|\/$/g, '');
                if (activeRoute === '') {
                    activeRoute = 'home';
                }
                this.menuByRoute(activeRoute.replace(/\//g, '-'));
            }
        });
    }

    ngOnInit(): void {
        this.cmsService.getSettings().subscribe();
        this.menuService.menuGroups();

        if (this.router.url.includes('/products/')) {
            if (this.deviceType === 'mobile') {
                this.thresholdGoToTop = 1100;
            }
            if (this.deviceType === 'tabletV') {
                this.thresholdGoToTop = 1100;
            }
            if (this.deviceType === 'tabletH') {
                this.thresholdGoToTop = 1500;
            }
            if (this.deviceType === 'desktop') {
                this.thresholdGoToTop = 1000;
            }
        }
    }


    menuByRoute(route) {
        this.menuService.menuByRoute(route);
    }
}
